import React from 'react';

/**
 * ProBadge Component - Display Pro badge for premium features
 * @param {string} size - 'sm', 'md', 'lg' (default: 'md')
 * @param {string} className - Additional CSS classes
 */
const ProBadge = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-xs px-2 py-1',
    lg: 'text-sm px-3 py-1.5'
  };

  return (
    <span 
      className={`inline-flex items-center bg-gradient-to-r from-amber-400 to-orange-500 text-white font-bold rounded-full ${sizeClasses[size]} ${className}`}
      style={{ letterSpacing: '0.5px' }}
    >
      ⭐ PRO
    </span>
  );
};

export default ProBadge;
